(function () {
  var RETRY_INTERVAL = 100;
  var MAX_RETRIES = 100;

  function getCustomUrlByMilestone(milestone) {
    var byId = (window.salepifyMilestoneImages && window.salepifyMilestoneImages.byId) || {};
    var milestoneId = milestone && milestone.id != null ? String(milestone.id) : '';
    return byId[milestoneId] || '';
  }

  function applyOverride() {
    var embed = window.tlCartGoalEmbed;
    if (!embed || typeof embed.getMilestoneIcon !== 'function') {
      return false;
    }

    if (embed.__salepifyMilestoneOverrideApplied) {
      return true;
    }

    var originalGetMilestoneIcon = embed.getMilestoneIcon.bind(embed);

    embed.getMilestoneIcon = function (milestone, milestoneIndex) {
      var customUrl = getCustomUrlByMilestone(milestone);

      if (!customUrl) {
        return originalGetMilestoneIcon(milestone, milestoneIndex);
      }

      return {
        isCustom: true,
        isCustomImage: true,
        imgSrc: customUrl
      };
    };

    embed.__salepifyMilestoneOverrideApplied = true;

    if (typeof embed.renderAllCartGoals === 'function') {
      requestAnimationFrame(function () {
        embed.renderAllCartGoals();
      });
    }

    return true;
  }

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;

    if (applyOverride() || attempts >= MAX_RETRIES) {
      clearInterval(timer);
    }
  }, RETRY_INTERVAL);
})();
